import axios from 'axios';

export function getNationalities(query) {
    return axios({
        method: 'get',
        url: `/api/v2/nationalities?q=${encodeURIComponent(query)}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}




// WEBPACK FOOTER //
// ./app/services/nationalities.js